import { LOADING_INDICATOR_TEXT } from '../constants';

interface Props {
    isLoading: boolean;
}

const Loader = ({ isLoading }: Props) => {
    if (!isLoading) {
        return null;
    }

    return (
        <div className="loader">
            <div className="loader-text">{LOADING_INDICATOR_TEXT}</div>
        </div>
    );
};

export default Loader;
